// src/components/ui/alert.jsx
const Alert = ({ className, variant = "default", ...props }) => {
    const variantClasses = {
        default: "bg-background text-foreground",
        destructive: "bg-destructive/15 text-destructive dark:border-destructive"
    };

    return (
        <div
            role="alert"
            className={`relative w-full rounded-lg border p-4 ${variantClasses[variant]} ${className || ''}`}
            {...props}
        />
    );
};

const AlertDescription = ({ className, ...props }) => (
    <div className={`text-sm [&_p]:leading-relaxed ${className || ''}`} {...props} />
);

export { Alert, AlertDescription };